const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "side_blocks": {
    "fr": [
      "15811640"
    ]
  },
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "mapbox_token": "pk.eyJ1IjoibWltaXJvc2UyOSIsImEiOiJjbGV3cHhsaGgxMHV2NDNtazAxOGM0MXhrIn0.LieDdLfJevyJ6njBc9-vQg",
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "last_news_label": {
    "fr": "Actualités"
  },
  "search_placeholder": {
    "fr": "Recherche"
  },
  "display_contact": true,
  "fb_display": false,
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form",
  "contact_label": {
    "fr": "Renseignements"
  },
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "twitter_display": false,
  "api_url": "https://api-v2.mobireport.fr",
  "website_name": "Keolis Sud Lorraine",
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "time_format": {
    "fr": "HH:mm"
  },
  "search_title": {
    "fr": "Recherche"
  },
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "contact_phone_number": {
    "fr": "03 83 30 89 99"
  },
  "primary_color": {
    "red": 0,
    "green": 170,
    "blue": 195,
    "alpha": 255
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "search_button_label": {
    "fr": "Rechercher"
  },
  "alt_text": {
    "fr": "Renseignements : 03 83 30 89 99"
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "gradient_primary_color": {
    "red": 4,
    "green": 201,
    "blue": 231,
    "alpha": 255
  },
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "search_icon_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 1
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "gradient_button_color": {
    "red": 20,
    "green": 195,
    "blue": 175,
    "alpha": 255
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "active_button_text_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "secondary_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "search_token": "991a3ccd4dbaab45ff7d52aa4045fc",
  "subsidiary_logo": {
    "path": "/71921/1697026054-keolis-sud-lorraine-white.png",
    "format": "png",
    "size": 18325,
    "alt": "Logo Keolis Sud Lorraine",
    "title": "Keolis Sud Lorraine",
    "width": 1536,
    "height": 473
  },
  "back_to_home_title": {
    "fr": "Keolis Sud Lorraine – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "piano_site_id": "639231",
  "google_tag_manager_id": "GTM-M9VBW36",
  "google_analytics_key": "",
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "actistat_key": "",
  "loader": {
    "path": "/71921/1693498445-loader-bleu-keolis.gif",
    "format": "gif",
    "size": 795545,
    "alt": "Page en chargement, veuillez patientez s'il vous plaît",
    "title": "Page en chargement",
    "width": 1080,
    "height": 1080
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [
    "15811760"
  ],
  "form_captcha_key": "6Lcd1DMjAAAAAEsHVSyCqBSA_c8IBpjJStjgY_pH",
  "updated_at": "2025-07-31T12:25:10.241+02:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://www.keolissudlorraine.com",
  "readOnlyApi": "670254ab105c9b63f32a4f600ca4a4"
}